<div fxLayout="column" class="p-a-xl cipo--height--full">
    <mat-form-field fxFlex="none" appearance="outline">
        <mat-label>Demo text</mat-label>
        <textarea matInput [(ngModel)]="test"></textarea>
        <mat-hint>Text to show in the demo</mat-hint>
    </mat-form-field>
    <div fxFlex="grow" class="cipo--overflow--auto">
        <div>
            <h4 class="m-b">Generate spacing class</h4>
            <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
                <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="spacingType">
                        @for (type of SPACING_CLASSES.types | keyvalue; track $index) {
                            <mat-option [value]="type.key">{{ type.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Position</mat-label>
                    <mat-select [(ngModel)]="spacingPosition">
                        @for (position of SPACING_CLASSES.positions | keyvalue; track $index) {
                            <mat-option [value]="position.key">{{ position.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Value</mat-label>
                    <mat-select [(ngModel)]="spacingValue">
                        @for (val of SPACING_CLASSES.values | keyvalue; track $index) {
                            <mat-option [value]="val.key">{{ val.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @let spacingClass = spacingType + "-" + spacingPosition + (spacingValue ? "-" + spacingValue : "");
                <div class="demo-container">
                    <div [class]="spacingClass + ' cipo-bg--accent-200 demo-content'">
                        <p class="cipo-bg--primary-700 cipo-text--white p-x-sm">{{ test }}</p>
                    </div>
                </div>
                <div
                    (click)="copyContent(spacingClass)"
                    class="cipo--cursor--pointer cipo-bg--black-200 p-a-sm cipo--border-radius--xs"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <p>{{ spacingClass }}</p>
                    <mat-icon inline>content_copy</mat-icon>
                </div>
            </div>
        </div>
        <div>
            <h4 class="m-y">Generate colors class</h4>
            <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
                <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="colorType">
                        @for (type of COLOR_CLASSES.types | keyvalue; track $index) {
                            <mat-option [value]="type.key">{{ type.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Palette</mat-label>
                    <mat-select [(ngModel)]="colorPalette">
                        @for (palette of COLOR_CLASSES.palettes | keyvalue; track $index) {
                            <mat-option [value]="palette.key">{{ palette.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Hue</mat-label>
                    <mat-select [(ngModel)]="hue">
                        @for (hue of COLOR_CLASSES.hues | keyvalue; track $index) {
                            <mat-option [value]="hue.key">{{ hue.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @let colorClass = "cipo-" + colorType + "--" + colorPalette + "-" + hue;
                <div class="demo-container">
                    <div [class]="colorClass + ' demo-content'">
                        <p class="p-x-sm">{{ test }}</p>
                    </div>
                </div>
                <div
                    (click)="copyContent(colorClass)"
                    class="cipo--cursor--pointer cipo-bg--black-200 p-a-sm cipo--border-radius--xs"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <p>{{ colorClass }}</p>
                    <mat-icon inline>content_copy</mat-icon>
                </div>
            </div>
        </div>
        <div>
            <h4 class="m-y">Generate text class</h4>
            <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
                <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="textType" (valueChange)="onTextTypeChange($event)">
                        @for (item of TEXT_CLASSES | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Value</mat-label>
                    <mat-select [(ngModel)]="textValue">
                        @for (item of TEXT_CLASSES[textType].values | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @let textClass = textType + "--" + textValue;
                <div class="demo-container p-a">
                    <div [class]="textClass">{{ test }}</div>
                </div>
                <div
                    (click)="copyContent(textClass)"
                    class="cipo--cursor--pointer cipo-bg--black-200 p-a-sm cipo--border-radius--xs"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <p>{{ textClass }}</p>
                    <mat-icon inline>content_copy</mat-icon>
                </div>
            </div>
        </div>
        <div>
            <h4 class="m-y">Generate border class</h4>
            <p class="cipo-text--medium-lg">
                The demo has a border by default, so we could see radius and color. When you select a border type, it
                replaces only the selected position.
                <br />
                To see only selected border value, pick 'all' on the first select
            </p>
            <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
                <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="borderType" (valueChange)="onBorderTypeChange($event)">
                        @for (item of BORDERS_CLASSES | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Value</mat-label>
                    <mat-select [(ngModel)]="borderValue">
                        @for (item of BORDERS_CLASSES[borderType].values | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @let borderClass = "cipo--border" + borderType + "--" + borderValue;
                <div class="p-a">
                    <div [class]="'demo-container cipo-bg--white ' + borderClass">
                        <p class="m-a-sm">{{ test }}</p>
                    </div>
                </div>
                <div
                    (click)="copyContent(borderClass)"
                    class="cipo--cursor--pointer cipo-bg--black-200 p-a-sm cipo--border-radius--xs"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <p>{{ borderClass }}</p>
                    <mat-icon inline>content_copy</mat-icon>
                </div>
            </div>
        </div>
        <div>
            <h4 class="m-y">Generate general class</h4>
            <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
                <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="generalType" (valueChange)="onGeneralTypeChange($event)">
                        @for (item of GENERAL_CLASSES | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Value</mat-label>
                    <mat-select [(ngModel)]="generalValue">
                        @for (item of GENERAL_CLASSES[generalType].values | keyvalue; track $index) {
                            <mat-option value="{{ item.key }}">{{ item.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @let generalClass = "cipo--" + generalType + "--" + generalValue;
                <div class="demo-container p-a">
                    <div [class]="generalClass">{{ test }}</div>
                </div>
                <div
                    (click)="copyContent(generalClass)"
                    class="cipo--cursor--pointer cipo-bg--black-200 p-a-sm cipo--border-radius--xs"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">
                    <p>{{ generalClass }}</p>
                    <mat-icon inline>content_copy</mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
